import logo from './logo.svg';
import './App.css';
import Contact from './Components/Contact/Contact';

function App() {
  return (
    <div>
      <Contact/>
    </div>
  );
}

export default App;
